import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { ListMenu } from "../../../theme/Component/ListMenu";
import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _single, _SpareInventoried, _SpareInventoriedType } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { SelectConstantsValue } from "../../../theme/Component/SelectConstantsValue";
import useModal, { MODAL_LG } from "../../../theme/Component/hooks/useModal";
import { SpareInventoried } from "./SpareInventoried/SpareInventoried";

interface Form {
    State: number;
    Location: number;
}

export const SpareInventoriedType = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_SpareInventoriedType);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Eliminar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalItems = useModal(`Items - ${bean.Name}`, MODAL_LG)

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        const props = {
            State: 1
        }
        instance.getSpareInventoriedTypeCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => { toast.error(err) })
    }

    const create = () => {
        setBean({
            State: 1,
        });
        setModal({ ...modal, "name": `Agregar Categoria de materia`, "view": true });
    }

    const deleteItem = () => {
        const x = { ...bean, State: 3 };
        editaItem(x);
        setModalC({ ...modalC, view: false });
    };

    const editaItem = (obj: any) => {
        //console.log(abilityType.bean);
        instance.updateSpareInventoriedType(obj).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDSpareInventoriedType', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
            { titulo: 'Abrir Objetos de la Categoria', icono: 'ri-list-ordered', visible: true, evento: () => { modalItems.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Inventarios de Mantenimiento">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                    <Modal modal={modal} updateModal={setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="col-md-12">
                                    <label>Nombre</label>
                                    <input className="form-control" type="text" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea value={bean.Description} className="form-control" onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                                </div>
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Description}</strong>
                    </ModalConfirm>

                    <Modal modal={modalItems.modal} updateModal={modalItems.setModal} >
                        <SpareInventoried spareType={bean} />
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}